import { FC } from "react";
import { SwitchLabelProps } from "./types";
import { twMerge } from "tailwind-merge";

const SwitchLabel: FC<SwitchLabelProps> = ({
  label,
  textClass,
  labelClassName,
}) => {
  if (!label) return null;

  if (typeof label === "string")
    return <p className={twMerge(labelClassName, textClass)}>{label}</p>;

  return <>{label}</>;
};

export default SwitchLabel;
